import { api } from '@/apis';
import { useQuery } from '@tanstack/react-query';
import { startOfDay, subDays } from 'date-fns';

export function useTotalAttendedIncidents(
  groupType,
  groupId,
  subgroupType,
  days,
) {
  return useQuery({
    queryKey: [
      'totalAttendedIncidents',
      groupType,
      groupId,
      subgroupType,
      days,
    ],
    queryFn: async () => {
      const start = subDays(startOfDay(new Date()), days);
      const json = [
        {
          $match: {
            attended: true,
            startTime: { $gt: start },
            ...(import.meta.env.DEV
              ? {}
              : { [`person.groups.${groupType}`]: groupId }),
          },
        },
        subgroupType !== 'collarNumber' && {
          $unwind: {
            path: `$person.groups.${subgroupType}`,
            preserveNullAndEmptyArrays: true,
          },
        },
        {
          $group: {
            _id: {
              identifier: {
                $ifNull: [
                  subgroupType === 'collarNumber'
                    ? '$person.collarNumber'
                    : `$person.groups.${subgroupType}`,
                  'Unknown',
                ],
              },
              grade: '$incident.grade',
            },
            incidentNumbers: { $addToSet: '$incident.number' },
          },
        },
        {
          $project: {
            _id: false,
            identifier: '$_id.identifier',
            grade: '$_id.grade',
            count: { $size: '$incidentNumbers' },
          },
        },
      ].filter(Boolean);

      const response = await api
        .post('pipeline/personIncidentResponses', { json })
        .json();

      return response.reduce(
        (accumlator, { identifier, grade, count }) => {
          if (!accumlator.counts[identifier]) {
            accumlator.counts[identifier] = {};
          }

          accumlator.counts[identifier][grade ?? 'Unknown'] = count;
          accumlator.grades.add(grade ?? 'Unknown');

          return accumlator;
        },
        { counts: {}, grades: new Set() },
      );
    },
    placeholderData: { counts: {}, grades: new Set() },
  });
}
